const buttonListMap = {
  linkMan: ['addContacter', 'editContacter', 'calling', 'delContacter'],
  callRecord: ['addFollow'],
  schedule: ['addSchedule', 'editSchedule', 'delSchedule', 'addFollow'],
  invoice: ['addInvoice', 'editInvoice', 'delInvoice'],
  address: ['addAddress', 'editAddress', 'delAddress'],
  cloud: ['addDocument', 'copyDocument', 'uploadAttachments', 'downAttachments', 'delAttachments'],
  priceInfo: ['addPrice', 'editPrice', 'delPrice'],
  follow: ['addCollaborator', 'manageCollaborator', 'addGroup'],
  collaborator: ['addFollow', 'editFollow'],
  approvalRecord: ['approvalRecords', 'cancelApproved'],
  customerLinkMan: ['addContacter', 'editContacter', 'delContacter']
};

const ruleMap = {
  1: 'clue',
  2: 'customer',
  3: 'businessOpportunity',
  4: 'product',
  6: 'priceSheet',
  7: 'priceSheetProduct',
  8: 'contract',
  9: 'contractProduct',
  10: 'saleOrder',
  11: 'saleOrderProduct',
  12: 'afterSale',
  13: 'returnOrder',
  14: 'returnOrderProduct',
  16: 'dynamicRecord',
  31: 'businessOpportunity',
  32: 'businessOpportunityProduct',
  99: '',
  101: 'cluePool'
};
/**
 *
 * @param buttonList: 所有按钮，type: 业务类型，entity: 业务实体 props
 * @returns 符合条件的按钮集合
 */
function getButtonResult(props) {
  const { buttonList, type, entity, isTab } = props;
  let handleArray;
  if (entity >= 200) {
    // 自定义对象
    handleArray = buttonListMap[type].map((item) => `${entity}:${item}`);
  } else {
    handleArray = buttonListMap[type].map((item) => `${ruleMap[entity]}:${item}`);
  }

  if (isTab) {
    return handleArray;
  }

  console.log('handleArray', handleArray);

  const result = buttonList.filter((item) => handleArray.includes(item.value));
  return result;
}

export { getButtonResult, ruleMap };
